export enum InviteStatuses {
    Sent = 1,
    Rejected,
    Accepted
}